import React from "react";

import { PersonalDetailsStateProviderProps } from "./types";
import PersonalDetails from "./PersonalDetails";

const StateProvider: React.FC<PersonalDetailsStateProviderProps> = ({
  personId,
  name,
  dateOfBirth,
  address,
  emailAddress,
  mobileNumber = "",
  landlineNumber = "",
  loading = false,
}) => (
  <PersonalDetails
    personId={personId}
    name={name}
    dateOfBirth={dateOfBirth}
    address={address}
    emailAddress={emailAddress}
    mobileNumber={mobileNumber}
    landlineNumber={landlineNumber}
    loading={loading}
  />
);

export default StateProvider;
